import { styled } from '@mui/material/styles';
import ListItemIcon, { ListItemIconProps } from '../ListItemIcon';

export type { ListItemIconProps as SidebarMenuItemIconProps };

const SidebarMenuItemIcon = styled(ListItemIcon)(({ theme }) => ({
  [theme.breakpoints.between('md', 'xl')]: {
    minWidth: 0,
  },
}));

export default SidebarMenuItemIcon;
